var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponsive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.115,
    cy: 64.644,
    r: 2.347
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.636 45.14h-6.454V22.062c0-3.979-3.237-7.215-7.216-7.215H12.265c-3.979 0-7.216 3.237-7.216 7.215v44.224c0 3.979 3.237 7.216 7.216 7.216H32.35v8.192H21.553a1.5 1.5 0 0 0 0 3h47.125a1.5 1.5 0 0 0 0-3H57.881v-8.192h14.531v8.338a3.318 3.318 0 0 0 3.314 3.315h15.909a3.319 3.319 0 0 0 3.315-3.315V48.455a3.319 3.319 0 0 0-3.315-3.315Zm.315 3.315v25.406H75.412V48.455c0-.174.141-.315.314-.315h15.909c.174 0 .315.141.315.315ZM12.265 17.846h65.701a4.22 4.22 0 0 1 4.216 4.215v23.078h-6.455a3.318 3.318 0 0 0-3.314 3.315v7.615H8.049V22.062a4.22 4.22 0 0 1 4.216-4.215Zm42.616 63.847H35.35v-8.192h19.531v8.192Zm1.5-11.192H12.265a4.222 4.222 0 0 1-4.216-4.216v-7.216h64.363v11.432H56.381Zm35.255 11.653H75.727a.315.315 0 0 1-.314-.315V76.86h16.539v4.979a.316.316 0 0 1-.315.315Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.682 78.315a1.164 1.164 0 1 0 0 2.328 1.164 1.164 0 0 0 0-2.328Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.e51d007afbe1cf632422b00813b15c22.svg";
export { ForwardRef as ReactComponent };